import { useMutation } from '@tanstack/react-query';
import { VerifyProductBarcodePayload } from '../interface/interface';
import { verifyProductBarcode } from '../service/verifyProductBarcode';

const useVerifyProductBarcode = () => {
  return useMutation({
    mutationKey: ['verifyProductBarcode'],
    mutationFn: ({
      accessToken,
      orderId,
      barcode,
    }: VerifyProductBarcodePayload) =>
      verifyProductBarcode(accessToken, orderId, barcode),
  });
};

export default useVerifyProductBarcode;
